/*
* Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
*/
/*******************************************************************
 * @author Soongjin Park
 * @contact sjpark@detech.co.kr
 * @date 2022-09-20
 * @brief EHP 메뉴 관리 개발
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
import { loadingBoxState } from "../../../recoil/menuState";
/**
 * @brief EHP 메뉴 관리 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function SiteTree(props) {
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    // props
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const workMode = props.workMode;
    const tabType = props.tabType;
    const setParentPopWin = props.setPopWin;
    //
    //화면 이동
    const navigate = useNavigate();
    //
    const [menuList, setMenuList] = useState([
        { "menuId": 0, "menuName": "메뉴별 권한 설정", "adminType": "AUTH" },
        { "menuId": 1, "menuName": "다국어 설정", "adminType": "LANG" },
    ]);
    useEffect(() => {
        // tree 초기화 - 선택
        setParentSelTree(menuList[0].adminType, {
            menu: { "menuId": menuList[0].menuId, "menuName": menuList[0].menuName, },
        });
    }, []);
    /*
    const { data: retData, error, isLoading, reload, run, } = useAsync({
      promiseFn: HTTPUTIL.PromiseHttp,
      httpMethod: "GET",
      appPath: `/api/v2/product/companies`,
      appQuery: {},
      userToken: userInfo.loginInfo.token, // url 직접 접근시 로그인 정보 사라짐..
      watch: adminType + workMode + selTree.reload
    });
  
    useEffect(() => {
      setRecoilIsLoadinBox(true);
      const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
      if (ERR_URL.length > 0) navigate(ERR_URL);
      if (retData) {
        //clog("IN SITETREE : RES : " + JSON.stringify(retData.body));
        if (retData.codeNum == CONST.API_200) {
          setCompanyList(retData.body);
          setParentSelTree(adminType, {...selTree, reload:false});
        }
      }
      setRecoilIsLoadinBox(false);
    }, [retData])
    */
    function onClickGoMenu(e, menu) {
        e.stopPropagation();
        setParentSelTree(menu.adminType, {
            menu: { "menuId": menu.menuId, "menuName": menu.menuName, },
        });
        setParentWorkMode("READ");
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "area__left" },
            React.createElement("div", { className: "lnb" },
                React.createElement("ul", { className: "lnb-depth1" }, menuList.map((menu, idx) => (React.createElement("li", { key: `menu_${idx.toString()}`, className: (menu.menuId === selTree.menu.menuId) ? "active" : "" },
                    React.createElement("p", null,
                        React.createElement("a", { onClick: (e) => onClickGoMenu(e, menu) },
                            React.createElement("span", null, menu.menuName)))))))))));
}
;
export default SiteTree;
